module.exports = __webpack_public_path__ + "static/Ogg-Roman-830f34e1e522d3d7c7db2704475a2d97.woff2";